import React, { createContext, useState, useContext, useRef } from 'react';
import { BasicStates, BasicEvents, basicHooks, basicTransitions } from '../fsm/AutoPlayBaseFSM';

const AutoPlayContext = createContext();

export const AutoPlayProvider = ({ children }) => {
    const [autoPlayState, setAutoPlayState] = useState(BasicStates.IDLE);
    const timerRef = useRef(null);
    const [ui, setUi] = useState({
        contentTableDisabled: false,
        contentAdvanceRowToken: 0,
        contentPlayRowToken: 0,
        voiceRecordingDisabled: false,
        contentControlsDisabled: false,
        stopplay: 0,

    });
    let playDuration = 2000; // Default play duration
 


    // Timer helpers for hooks
    const ctx = {
        autoPlayState,
        timerRef,
        ui,
        setUi,
        // playDuration,
        
        dispatch: (event) => handleAutoPlayEvent(event),
        startTimer: (ms, cb) => {
            ctx.clearTimer();
            timerRef.current = setTimeout(cb, ms);
        },

        startTimer1: ( cb) => {
            ctx.clearTimer();
            console.log('Starting timer1: ', playDuration);
            timerRef.current = setTimeout(cb, playDuration);
        },
        
        clearTimer: () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        },
    };

    const handleAutoPlayEvent = (event) => {
        console.log('AutoPlay Event:', event);
        const nextPlayDuration = Number(event?.playDuration);
        if (Number.isFinite(nextPlayDuration) && nextPlayDuration >= 0) {
            playDuration = Math.round(nextPlayDuration * 1000);
        }



        // let eventDuration = event?.duration || eventDuration; // Update duration if provided in event

        // playDuration = event?.playDuration || playDuration; // Update playDuration if provided in event
        setAutoPlayState(prevState => {
            const transitions = basicTransitions[prevState];
            const nextState = (transitions && transitions[event.type]) ? transitions[event.type] : prevState;

            // Call onExit for prevState if defined
            if (basicHooks.onExit && basicHooks.onExit[prevState]) {
                basicHooks.onExit[prevState](ctx, event);
            }

            // Call onEnter for nextState if defined (after state update)
            setTimeout(() => {
                if (basicHooks.onEnter && basicHooks.onEnter[nextState]) {
                    basicHooks.onEnter[nextState](ctx, event);
                }
            }, 0);

            console.log(`AutoPlay FSM: ${prevState} --(${event.type} : ${event?.timestamp})-> ${nextState}`);
            return nextState;
        });
    };

    return (
        <AutoPlayContext.Provider value={ctx}>
            {children}
        </AutoPlayContext.Provider>
    );
};

export const useAutoPlay = () => useContext(AutoPlayContext);
